import { IRequestTemplate } from 'legacy/lut/classes/models/onboarding/RequestTemplate'

export class LinkedSpecializationError extends Error {
  constructor(
    public readonly message: string,
    protected readonly linkedRequestTemplates: IRequestTemplate[]
  ) {
    super(message)
  }

  public getLinkedRequestTemplates(): IRequestTemplate[] {
    return this.linkedRequestTemplates
  }
}
